<template>
  <div v-if="isUserAdmin()">

    <div class="text-2xl">
      # New brokers per week {{ year }}
    </div>

    <div class="" v-if="chartData != null">
      <BarChart v-bind:chartData="chartData" v-bind:height="600"></BarChart>
    </div>

  </div>
</template>

<script>
  import { EventBus } from '@/shared/event-bus'
  import BarChart     from '@/shared/components/charts/Bar.js'

  export default {

    components: {
      BarChart,
    },

    data() {
      return {
        chartData: null,
        year: '' 
      }
    },

    created() {
      this.getData();
      this.year = this.$route.params.year
    },

    watch : {
      'type' : function(newVal, oldVal) {
        this.getData()
      }
    },

    methods : {
      getData() {
        this.apiGet({
          year : this.$route.params.year
        }, 'metric/new-brokers-per-week', (data) => {
          this.chartData = data
        })
      }
    }
  }
</script>
